import React, { useEffect, useState } from 'react'
import Layout from '../../../components/Layout/Layout'
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { Modal } from 'antd'
import { toast } from 'react-toastify'

const categories = [
  {
    label: 'ER Shop',
    path: (id) => `/admin/stock-check/er-shop/${id}`,
    resetEndpoint: (id) => `/api/v1/admin/stock-check/reset-data/${id}`,
  },
  {
    label: 'Mobile',
    path: (id) => `/admin/stock-check/mobile/${id}`,
    resetEndpoint: (id) => `/api/v1/admin/stock-check-mobile/reset-data/${id}`,
  },
  {
    label: 'MW-102',
    path: (id) => `/admin/stock-check/rack-box/${id}`,
    resetEndpoint: (id) => `/api/v1/admin/stock-check-store/reset-data/${id}`,
  },
  {
    label: 'MW-Conference',
    path: (id) => `/user/stock-check/ss15/conference/${id}`,
    resetEndpoint: (id) =>
      `/api/v1/general/stock-check/reset-conference-data/${id}`,
  },
  // {
  //   label: 'MW-ER',
  //   path: (id) => `/user/stock-check/ss15/ershop/${id}`,
  // },
]

const AdminStockCategory = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [eventTitle, setEventTitle] = useState('')
  const [loading, setLoading] = useState(true)
  const [resettingCategory, setResettingCategory] = useState('')
  const [visibleResetModal, setVisibleResetModal] = useState(false)

  useEffect(() => {
    const fetchEventTitle = async () => {
      try {
        const response = await axios.get(
          `/api/v1/admin/stock-check/get-title/${id}`
        )
        setEventTitle(response.data.event)
      } catch (error) {
        console.error('Failed to fetch event title:', error)
      } finally {
        setLoading(false)
      }
    }

    if (id) {
      fetchEventTitle()
    }
  }, [id])

  const handleReset = async (category) => {
    setResettingCategory(category.label)
    try {
      await axios.delete(category.resetEndpoint(id))
      setVisibleResetModal(false)
      toast.success(`${category.label} data reset successfully`)
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to reset data')
    } finally {
      setResettingCategory('')
    }
  }

  return (
    <Layout title={'Stock Category'}>
      <div
        className='shadow-sm px-3 px-md-4 py-3 bg-white'
        style={{ width: '100%', position: 'fixed', zIndex: 1000 }}
      >
        <div className='d-flex justify-content-between align-items-center gap-3'>
          <div className='text-truncate'>
            <div className='fw-bold fs-5 text-truncate'>
              {loading ? (
                <span className='placeholder-glow'>
                  <span className='placeholder col-8'></span>
                </span>
              ) : (
                eventTitle
              )}
            </div>
          </div>
          <div className='d-flex gap-2 flex-shrink-0'>
            <button
              type='button'
              className='btn btn-danger btn-sm'
              onClick={() => setVisibleResetModal(true)}
            >
              Reset
            </button>
            <button
              type='button'
              className='btn btn-secondary btn-sm'
              onClick={() => navigate('/admin/stock-check-list')}
            >
              Back
            </button>
          </div>
        </div>
      </div>

      <div
        className='container-fluid px-3 px-md-4'
        style={{ paddingTop: '80px' }}
      >
        <div className='row g-4'>
          {categories.map((category) => (
            <div className='col-6 col-md-4 col-xl-3' key={category.label}>
              <Link
                to={category.path(id)}
                className='card h-100 text-decoration-none stock-category-tile'
              >
                <div className='card-body d-flex align-items-center justify-content-center text-center py-3'>
                  <div className='fw-semibold'>{category.label}</div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <Modal
        closable={false}
        footer={null}
        onCancel={() => setVisibleResetModal(false)}
        open={visibleResetModal}
        title='Reset Data'
      >
        <p className='text-danger mb-3'>
          This will delete all related data and cannot be undone.
        </p>
        <div className='d-grid gap-2'>
          {categories.map((category) => (
            <button
              type='button'
              className='btn btn-outline-danger text-start'
              key={category.label}
              onClick={() => handleReset(category)}
              disabled={Boolean(resettingCategory)}
            >
              {resettingCategory === category.label ? (
                <span
                  className='spinner-border spinner-border-sm me-2'
                  role='status'
                  aria-hidden='true'
                ></span>
              ) : null}
              Reset {category.label}
            </button>
          ))}
        </div>
        <div className='text-end mt-3'>
          <button
            type='button'
            className='btn btn-secondary btn-sm'
            onClick={() => setVisibleResetModal(false)}
            disabled={Boolean(resettingCategory)}
          >
            Cancel
          </button>
        </div>
      </Modal>

      <style>{`
        .stock-category-tile {
          color: rgb(47, 68, 131);
          border-color: rgba(47, 68, 131, 0.25);
          transition: transform 0.15s ease, box-shadow 0.15s ease,
            background-color 0.15s ease, color 0.15s ease;
        }
        .stock-category-tile:hover,
        .stock-category-tile:focus-visible {
          background-color: rgb(47, 68, 131);
          border-color: rgb(47, 68, 131);
          color: #fff;
          transform: translateY(-2px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </Layout>
  )
}

export default AdminStockCategory
